import {BookingResponseType} from 'types/bookingResponse'
import {ErrorResponse} from '@daedalus/core/src/booking/types/ErrorResponse'
import {LinkType} from '@daedalus/core/src/booking/types/Link'
import {$AxiosXHR} from 'axios'
import {ServerCode} from 'services/psd2'
import {createAction} from '@reduxjs/toolkit'
import {BookingRequestWithPsd2} from '@daedalus/core/src/booking/types/BookingRequest'

export const BOOK_OFFER_FINALIZATION = 'BOOK_OFFER_FINALIZATION'
export const BOOK_OFFER_FINALIZATION_PENDING = 'BOOK_OFFER_FINALIZATION_PENDING'
export const BOOK_OFFER_FINALIZATION_ERROR = 'BOOK_OFFER_FINALIZATION_ERROR'
export const BOOK_OFFER_FINALIZATION_DONE = 'BOOK_OFFER_FINALIZATION_DONE'

export interface BookOfferFinalizationData {
  serverCode: ServerCode
}

export type BookOfferFinalizationParamsType = {
  link: LinkType
  payload: BookingRequestWithPsd2
  providerCode: string
}

export type BookOfferFinalizationType = {
  type: typeof BOOK_OFFER_FINALIZATION
  data: BookOfferFinalizationData
}

type BookOfferFinalizationPendingType = {
  type: typeof BOOK_OFFER_FINALIZATION_PENDING
}

type BookOfferFinalizationDoneType = {
  data: BookingResponseType
  type: typeof BOOK_OFFER_FINALIZATION_DONE
}

type BookOfferFinalizationErrorType = {
  data: BookOfferFinalizationErrorType
  type: typeof BOOK_OFFER_FINALIZATION_ERROR
}

export type ActionType =
  | BookOfferFinalizationType
  | BookOfferFinalizationPendingType
  | BookOfferFinalizationDoneType
  | BookOfferFinalizationErrorType

export const bookOfferFinalization = (
  finalizationData: BookOfferFinalizationData
): BookOfferFinalizationType => ({
  type: BOOK_OFFER_FINALIZATION,
  data: finalizationData
})

export const bookOfferFinalizationPending = (): BookOfferFinalizationPendingType => ({
  type: BOOK_OFFER_FINALIZATION_PENDING
})

export const bookOfferFinalizationDone = (
  response: $AxiosXHR<BookingResponseType>
): BookOfferFinalizationDoneType => ({
  type: BOOK_OFFER_FINALIZATION_DONE,
  data: response.data
})

export const bookOfferFinalizationError = ({
  ...error
}: $AxiosXHR<ErrorResponse>): BookOfferFinalizationErrorType => ({
  type: BOOK_OFFER_FINALIZATION_ERROR,
  data: error?.response?.data || error?.data
})

export const bookOfferFinalizationFatalError = createAction(
  'bookOffer/bookOfferFinalizationFatalError'
)
